import PropertyDetail from "../../commonComponents/productDetail/PropertyDetail";

const PropertyTabContainer = () => {
  return <PropertyDetail type="tabs" />;
};

export default PropertyTabContainer;
